import { downloadFileUrl3 } from '@/http/urls'

export const buildOssDownloadUrl = ({ fileName = '', name = '', preview } = {}) => {
  const params = []
  if (preview !== undefined && preview !== null) {
    params.push(`preview=${encodeURIComponent(preview)}`)
  }
  if (fileName) {
    params.push(`fileName=${encodeURIComponent(fileName)}`)
  }
  if (name) {
    params.push(`name=${encodeURIComponent(name)}`)
  }
  return `${downloadFileUrl3}${params.length ? `?${params.join('&')}` : ''}`
}
